import { createAction, props } from '@ngrx/store';
import { LastOpenedFormState } from '../state/last-opened-form.state';
import { NotificationIdentifier } from '@evorait/pace-core';
import { FormIdentifier } from '../../types/form-identifier';

export const tryToPerformPaceFormsQuickAccess = createAction(
    '[Forms] Trying to perform quick access for notification',
    props<{
        notification: NotificationIdentifier;
        equipmentId: string;
        materialNr: string;
        serialNr: string;
    }>(),
);
export const updateLastOpenedForm = createAction(
    '[Forms] Update last opened form for notification',
    props<{ notification: NotificationIdentifier; form: FormIdentifier }>(),
);
export const saveLastOpenedFormSuccess = createAction('[Forms] Successfully saved last opened form state');
export const deleteLastOpenedForm = createAction(
    '[Forms] Delete last opened form for notification',
    props<{
        notification: NotificationIdentifier;
    }>(),
);
export const restoreLastOpenedForm = createAction(
    '[Forms] Restore last opened form state',
    props<{
        lastOpenedForm: LastOpenedFormState;
    }>(),
);
